import { HowItWorksContentProps } from '@/components/cohort/HowItWorks/HowItWorks';

export const HowItWorksContent: HowItWorksContentProps = {
  eyebrow: 'TAKE THE NEXT STEP',
  heading: 'Calculate your numbers',
  subtext: 'We’ve slashed the time, paperwork and hassle. Get a quote fast and start saving!',
  gridItems: [
    {
      imgSrc: '/next-assets/images/cohort/hiw-calculate.svg',
      imgAlt: 'Calculator',
      title: 'Calculate',
      body: (
        <span>
          Compare your current loan, check your eligibility and calculate your repayments.
          <br />
          No credit checks here!
        </span>
      ),
      pill: '3 mins',
    },
    {
      imgSrc: '/next-assets/images/cohort/hiw-apply.svg',
      imgAlt: 'Clock',
      title: 'Apply',
      body: 'Our 15 minute online application is simple and gets you a decision in 60 seconds.',
      pill: '15 mins',
    },
    {
      imgSrc: '/next-assets/images/cohort/hiw-switch.svg',
      imgAlt: 'Arrows',
      title: 'Switch',
      body: 'Once approved, review and return your docs. We’ll get you settled and saving fast.',
      pill: '',
    },
  ],
};
